import React, { useState } from "react";
import { Paper, Stack, Toolbar, Typography, Button, Menu } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import MUIDataTable from "mui-datatables";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import PrintIcon from "@mui/icons-material/Print";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { TableHead, TableRow, TableCell } from "@mui/material";
import useStore from "../../Hooks/useStore";

function Datatable(props) {
  // For custom toolbar

  // console.log(props.data, "propsdata");
  const { setFetchAgain } = useStore();

  const [anchor, setAnchor] = useState(null);
  const open = Boolean(anchor);
  const rows = props?.data;
  let debounceTimeout;
  const fetchSearchData = async (searchText) => {
    try {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(async () => {
        props.setSearchTerm(searchText);
        setFetchAgain((prev) => !prev);
        console.log("Searching for", searchText);
      }, [1000]);
    } catch (error) {
      console.log(error, "error");
    }
  };

  // console.log(rows, "rows");
  const options = {
    elevation: 0,
    filterType: "multiselect",
    selectableRows: "none",
    selectableRowsHeader: false,
    download: true,
    print: true,
    search: true,
    searchPlaceholder: "Enter search key",
    searchAlwaysOpen: true,
    onSearchChange: (searchText) => {
      // setSearchString(searchText); // Capture the search string
      // console.log("Search String:", searchText);

      fetchSearchData(searchText);
    },
    serverSide: true,
    // draggable: true,
    // draggableColumns: { enabled: true },
    page: props?.page,
    // fixedSelectColumn: true,
    fixedHeader: true,
    fixedSelectColumn: true,
    tableBodyHeight: "calc(100vh - 225px)",
    // jumpToPage: true,
    // resizableColumns: true,
    rowsPerPage: props?.rowsPerPage,
    count: props?.totalCount,
    onTableChange: (action, tableState) => {
      switch (action) {
        case "changePage":
          props.setPage(tableState.page);
          break;
        case "changeRowsPerPage":
          props.setRowsPerPage(tableState.rowsPerPage);
          props.setPage(0);
          break;
      }
    },
    textLabels: {
      body: {
        noMatch: props?.loading
          ? "Loading data..."
          : "Sorry, no matching records found",
      },
    },
  };

  return (
    <Paper elevation={3}>
      {/* Custom Toolbar */}

      <div
        style={{
          overflowY: "hidden",
          flex: 1,
          padding: "0 1.5rem",
        }}
      >
        <MUIDataTable
          key={`page-${props.page}-${rows.length}`}
          className="m-3"
          data={props.loading ? [{ placeholder: "Loading..." }] : rows}
          columns={props.columns}
          options={options}
          components={{
            TableHead: (props) => (
              <TableHead>
                <TableRow style={{ backgroundColor: "#e1effb" }}>
                  {props.columns.map((column, index) => (
                    <TableCell
                      key={index}
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "center",
                      }} // Customize text color and style
                    >
                      {column.label || column.name}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
            ),
          }}
        />
      </div>
    </Paper>
  );
}

export default Datatable;
